import React, { Component, useRef } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Divider,
  MenuItem,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Button from "../../../../component/button";
import Input from "../../../../component/inputpm";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
  OpenItemIcon,
  EndItemIcon,
} from "../../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import {
  toApi,
  fromApi,
  normalizeDateTime,
} from "../../component/specification/characteristicMapper";
import DraggableResizablePaper from "../../../../component/resizablePaper/resizablePaper";
import { formatNumber } from "../../../../helper/numberFormatter";
// import { withStyles } from '@mui/styles';
class OfferingProductSpecCharacteristicsDialog extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      showLoading: false,
      productSpecifications: [],
      childData: {},
      expandedNodes: [],

      rowsPerPage: 10,
      page: 1,
      startRecord: 1,
      totalCount: 0,
      specificationSearchString: "",
      selectedSpecificationId: "",
      selectedSpecificationDescription: "",

      productCharacteristics: [],
      rowsPerPageCharacteristics: 20,
      pageCharacteristics: 1,
      startRecordCharacteristics: 1,
      totalCharacteristicsCount: 0,
      characteristicId: "",
      characteristicDescription: "",
      name: "",

      filteredProductCharacteristics: [],

      selectedProductId: "",
      selectedCharacteristics: [],
      errors: {},
      formDataAddSpec: {},
      existingProductSpecification: false,
      showProductSpecification: false,
    };

    this.state = { ...this.initialState };
  }

  handleAssignAll = () => {
    this.setState({ showProductSpecification: true });
    if (this.props.onCharacteristicsChange) {
      if (
        this.props.changedCharacteristics &&
        this.props.changedCharacteristics.length > 0
      ) {
        const updatedSelectedCharacteristics =
          this.state.selectedCharacteristics.map((selChar) => {
            if (selChar.action === "update") {
              return selChar;
            }
            const changedChar = this.props.changedCharacteristics.find(
              (ch) => ch.id === selChar.id && ch.specId === selChar.specId,
            );
            if (changedChar) {
              return {
                ...selChar,
                value: changedChar.value,
                format: changedChar.format,
              };
            }
            return selChar;
          });
        this.filterData(updatedSelectedCharacteristics);
      } else {
        this.filterData(this.state.selectedCharacteristics);
      }
    }
    this.props.setErrorMessage(
      this.props.t("CHARACTERISTIC_UPDATED_SUCCESSFULLY"),
      true,
    );
    this.props.onClose();
  };

  handleUnassignAll = () => {
    this.setState({ showProductSpecification: false });
    if (this.props.onCharacteristicsChange) {
      this.filterData("");
    }
  };

  handleChangeAddSpec = (event, id, specId, rowType, rowFormat) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      let updatedErrors = { ...prevState.errors };
      let updatedSelectedCharacteristics = [
        ...prevState.selectedCharacteristics,
      ];

      const existingData = prevState.formDataAddSpec[`${specId}_${id}`] || {};
      //let format = name === 'format' ? value : (existingData.format || '');
      /*let format = name === 'format'
                      ? value
                      : (existingData.format || prevState.selectedCharacteristics?.find(row => row.id === id)?.format || '');*/
      let format =
        name === "format" ? value : existingData.format || rowFormat || "";

      let isValid = true;
      let validatedValue = value;

      if (
        name === "value" &&
        (rowType?.toUpperCase() === "ENUMERATION" ||
          rowType?.toUpperCase() === "ENUM")
      ) {
        isValid = this.validateFormat(value, format);
        if (!isValid) {
          validatedValue = "-";
          updatedErrors[`${specId}_${id}`] =
            `Invalid value. Allowed: ${format.replace(/\|/g, ", ")}`;
        } else {
          delete updatedErrors[`${specId}_${id}`];
        }
      }

      const updatedFormData = {
        ...existingData,
        [name]: validatedValue,
        format: name === "format" ? value : format,
      };

      const updatedCharacteristic = {
        specId,
        id,
        value: updatedFormData.value || "",
        format: updatedFormData.format || "",
        action: "update",
      };

      const key = `${specId}_${id}`;
      const existingIndex = updatedSelectedCharacteristics.findIndex(
        (char) => char.id === id && char.specId === specId,
      );

      //if ((updatedFormData.value || '').trim()  && updatedFormData.value !== '-' && isValid) {
      //Allow empty value to store
      if (updatedFormData.value !== "-" && isValid) {
        if (existingIndex !== -1) {
          updatedSelectedCharacteristics[existingIndex] = updatedCharacteristic;
        } else {
          updatedSelectedCharacteristics.push(updatedCharacteristic);
        }
      } else {
        updatedSelectedCharacteristics = updatedSelectedCharacteristics.filter(
          (char) => !(char.id === id && char.specId === specId),
        );
      }

      return {
        formDataAddSpec: {
          ...prevState.formDataAddSpec,
          [key]: updatedFormData,
        },
        selectedCharacteristics: updatedSelectedCharacteristics,
        errors: updatedErrors,
      };
    });
  };

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };

  filterData = (characteristics) => {
    if (characteristics != "") {
      const filteredData = characteristics.map(
        ({ specId, id, value, format }) => ({
          specId: specId,
          id: id,
          value: value ? value : "",
          format: format ? format : "",
        }),
      );
      this.props.onCharacteristicsChange(filteredData);
    } else {
      this.props.onCharacteristicsChange("");
    }
  };

  getFeatureApplList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecificationAppl/${this.state.selectedProductId}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.specId) {
          if (res.data.productSpecCharacteristic.length > 0) {
            let formData = {};
            let updatedCharacteristics =
              res.data.productSpecCharacteristic.map(fromApi);

            if (this.props.changedCharacteristics?.length > 0) {
              let changedCharacteristics =
                this.props.changedCharacteristics.map(fromApi);
              changedCharacteristics.forEach((char) => {
                let cKeyId = `${char.specId}_${char.id}`;
                formData[cKeyId] = {
                  value: char.value,
                  format: char.format,
                };
              });
            } else {
              updatedCharacteristics.forEach((char) => {
                //formData[item.id] = item.value;
                let uKeyId = `${char.specId}_${char.id}`;
                formData[uKeyId] = {
                  value: char.value,
                  format: char.format,
                };
              });
            }
            this.setState({
              existingProductSpecification: true,
              selectedCharacteristics: updatedCharacteristics,
              formDataAddSpec: formData,
              selectedSpecificationId: res.data.specId,
              selectedSpecificationDescription: res.data.specName
                ? res.data.specName
                : res.data.specDescription,
              totalCharacteristicsCount: +res.headers["x-total-count"],
            });
            /*if (this.props.onCharacteristicsChange) {
                        this.filterData(updatedCharacteristics);
                    }*/
          } else {
            this.setState({
              selectedCharacteristics: [],
              totalCharacteristicsCount: 0,
            });
          }
          //this.getSpecificationList();
          this.getSpecificSpecificationDetail(res.data.specId);
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
      });
  };

  getSpecificSpecificationDetail = (specId) => {
    this.setState({ showLoading: true });
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications/${specId}`,
      "",
    )
      .then((res) => {
        if (res.data) {
          this.setState({
            productSpecifications: [res.data],
            selectedSpecificationId: specId,
            selectedSpecificationDescription: res.data.name
              ? res.data.name
              : res.data.description,
            selectedSpecificationPath: specId.toString(),
            totalCount: 1,
          });
          if (!this.state.expandedNodes.includes(specId.toString())) {
            this.setState((prevState) => ({
              expandedNodes: [...prevState.expandedNodes, specId.toString()],
            }));
          }
          if (res.data.productSpecCharacteristic.length > 0) {
            var productCharacteristics =
              res.data.productSpecCharacteristic.map(fromApi);
            const filteredProductCharacteristics = productCharacteristics
              .filter((pc) =>
                this.state.selectedCharacteristics.some(
                  (sc) => sc.id === pc.id && sc.specId === pc.specId,
                ),
              )
              .map((pc) => {
                const matchedCharacteristic =
                  this.state.selectedCharacteristics.find(
                    (sc) => sc.id === pc.id && sc.specId === pc.specId,
                  );
                return {
                  ...pc,
                  value: matchedCharacteristic?.value || pc.value,
                  format: matchedCharacteristic?.format || pc.format,
                };
              });

            this.setState({
              productCharacteristics: filteredProductCharacteristics.sort(
                (a, b) => a.name.localeCompare(b.name),
              ),
              totalCharacteristicsCount:
                res.data.productSpecCharacteristic.length,
            });
          } else {
            this.setState({
              productCharacteristics: [],
              totalCharacteristicsCount: 0,
            });
          }
        } else {
          this.setState({
            productSpecifications: [],
            totalCount: 0,
            selectedSpecificationId: "",
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
        this.setState({ showLoading: false });
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
        const errMsg =
          err?.response?.data?.message || this.props.t("DEFAULT_ERROR_MESSAGE");
        this.props.setErrorMessage(errMsg, false);
      });
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ ...this.initialState });
      this.getFeatureApplList();
    }
  }

  componentDidMount() {
    //console.log(this.state.selectedProductId,"----Dialog mounted for:", this.props.productId);

    if (this.props.productId !== null) {
      this.setState({ ...this.initialState });
      this.getFeatureApplList();
    }
  }

  //   componentDidMount() {
  //        this.getSpecificationList();
  //        this.getCharacteristicList();

  //   }

  getSpecificationList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    //console.log('===========this.state.selectedSpecificationId====',this.state.selectedSpecificationId)
    var url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC${this.state.selectedSpecificationId ? "&id=" + this.state.selectedSpecificationId : ""}`;
    if (this.state.specificationSearchString) {
      url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC&description=${this.state.specificationSearchString}`;
    }
    BusApiCall("GET", url, "", pageOptions)
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          this.setState({
            productSpecifications: res.data,
            totalCount: +res.headers["x-total-count"],
            selectedSpecificationId: res.data[0].id,
            selectedSpecificationDescription: res.data[0].name
              ? res.data[0].name
              : res.data[0].description,
            selectedSpecificationPath: res.data[0].id.toString(),
          });
          if (this.state.selectedSpecificationId) {
            this.handleExpand(
              this.state.selectedSpecificationId,
              this.state.selectedSpecificationDescription,
              [this.state.selectedSpecificationId],
            );
          } else {
            this.getCharacteristicList();
          }
        } else {
          this.setState({
            productSpecifications: [],
            totalCount: 0,
            selectedSpecificationId: "",
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
      });
  };

  getCharacteristicList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}${this.state.selectedSpecificationId ? "&specId=" + this.state.selectedSpecificationId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          var transformProductCharacteristics = res.data.map(fromApi);
          this.setState({
            productCharacteristics: transformProductCharacteristics,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
        //this.initializeCharacteristics();
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
      });
  };

  handleNodeClick = (id, description, path) => {
    const pathString = path.join("-"); // Convert path array to string
    this.setState(
      {
        selectedSpecificationId: id,
        selectedSpecificationDescription: description,
        selectedSpecificationPath: pathString, // Store path for highlighting
        productCharacteristics: [],
        totalCharacteristicsCount: 0,
      },
      () => {
        //this.getCharacteristicList(id);
        if (!this.state.existingProductSpecification) {
          this.getCharacteristicList();
        } else {
          this.replaceCharacteristicsWithAppl();
        }

        /*else{
               this.setState({
                   productCharacteristics: this.state.selectedCharacteristics,
                   totalCharacteristicsCount: this.state.selectedCharacteristics.length,
               })
            }*/
      },
    );
  };

  replaceCharacteristicsWithAppl = () => {
    this.setState({ showLoading: true });

    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC` +
        `${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}` +
        `${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}` +
        `${this.state.selectedSpecificationId ? "&specId=" + this.state.selectedSpecificationId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });

        if (res.data.length > 0) {
          var productCharacteristics = res.data.map(fromApi);
          const filteredProductCharacteristics = productCharacteristics
            .filter((pc) =>
              this.state.selectedCharacteristics.some(
                (sc) => sc.id === pc.id && sc.specId === pc.specId,
              ),
            )
            .map((pc) => {
              const matchedCharacteristic =
                this.state.selectedCharacteristics.find(
                  (sc) => sc.id === pc.id && sc.specId === pc.specId,
                );

              return {
                ...pc,
                value: matchedCharacteristic?.value || pc.value, // Replace value field if exists
                format: matchedCharacteristic?.format || pc.format,
              };
            });
          this.setState({
            productCharacteristics: filteredProductCharacteristics,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
      });
  };

  handleExpand = (id, description, path) => {
    const pathString = path.join("-"); // Convert array to a string

    this.handleNodeClick(id, description, path);

    this.setState((prevState) => ({
      expandedNodes: prevState.expandedNodes.includes(pathString)
        ? prevState.expandedNodes.filter((p) => p !== pathString)
        : [...prevState.expandedNodes, pathString],
    }));
  };

  renderTreeItems = (nodes, path = []) => {
    return nodes.map((node) => {
      const currentPath = [...path, node.id];
      const pathString = currentPath.join("-"); // Convert path to string
      const isSelected = this.state.selectedSpecificationPath === pathString;
      return (
        <TreeItem
          key={pathString} // Ensure unique key as a string
          nodeId={pathString} // Ensure nodeId is a string
          className={isSelected ? "selectedNode" : ""} // Apply class
          label={
            <div style={{ display: "flex", alignItems: "center" }}>
              {node.productSpecificationRelationship &&
              node.productSpecificationRelationship.length > 0 ? (
                <>
                  <div
                    style={{ paddingRight: "5px" }}
                    className={`expandIconWrapper ${this.state.expandedNodes.includes(pathString) ? "isOpen" : ""}`}
                    onClick={() =>
                      this.handleExpand(node.id, node.name, currentPath)
                    }
                  >
                    <OpenItemIcon />
                  </div>
                  <div
                    onClick={() =>
                      this.handleNodeClick(node.id, node.name, currentPath)
                    }
                  >
                    {node.name || node.description}
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{ paddingRight: "5px" }}
                    className={`expandIconWrapper`}
                  >
                    <EndItemIcon />
                  </div>
                  <div
                    onClick={() =>
                      this.handleNodeClick(node.id, node.name, currentPath)
                    }
                  >
                    {node.name || node.description}
                  </div>
                </>
              )}
            </div>
          }
        >
          {node.productSpecificationRelationship &&
            node.productSpecificationRelationship.length > 0 &&
            this.renderTreeItems(
              node.productSpecificationRelationship,
              currentPath,
            )}
        </TreeItem>
      );
    });
  };

  TableSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "25%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("VALIDATION_FORMAT")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("VALUE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.productCharacteristics.map((row) => (
              <TableRow key={`${row.specId}_${row.id}`}>
                <TableCell>
                  {row.specId === this.state.selectedSpecificationId
                    ? row.name
                    : row.specName
                      ? row.specName + "." + row.name
                      : row.name}
                  {/*{row.name}*/}
                </TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description || ""}
                </TableCell>
                <TableCell>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 10,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("VALIDATION_FORMAT")}
                      name="format"
                      divClass={classes.inputClass}
                      value={
                        this.state.formDataAddSpec[`${row.specId}_${row.id}`]
                          ?.format ??
                        row.format ??
                        ""
                      }
                      onChange={(e) =>
                        this.handleChangeAddSpec(
                          e,
                          row.id,
                          row.specId || "",
                          row?.valueType,
                          row.format || "",
                        )
                      }
                    />
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 10,
                    }}
                  >
                    {(row?.valueType?.toUpperCase() === "STRING" ||
                      row?.valueType?.toUpperCase() === "OBJECT") && (
                      <>
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          name="value"
                          divClass={classes.inputClass}
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                          multiline={true}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            const format =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.format ||
                              row.format ||
                              "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "NUMBER" && (
                      <>
                        <Input
                          type="text"
                          inputProps={{ pattern: "[0-9]*" }}
                          size={"small"}
                          variant={"outlined"}
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          name="value"
                          divClass={classes.inputClass}
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) => {
                            const onlyNumbers = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                            this.handleChangeAddSpec(
                              {
                                target: {
                                  name: e.target.name,
                                  value: onlyNumbers,
                                },
                              },
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            );
                          }}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            const format =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.format ||
                              row.format ||
                              "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            } else {
                              this.setState((prevState) => ({
                                formDataAddSpec: {
                                  ...prevState.formDataAddSpec,
                                  [`${row.specId}_${row.id}`]: {
                                    ...prevState.formDataAddSpec[
                                      `${row.specId}_${row.id}`
                                    ],
                                    value: isNaN(value) ? "" : value,
                                  },
                                },
                                errors: {
                                  ...prevState.errors,
                                  [`${row.specId}_${row.id}`]: isNaN(value)
                                    ? "Value must be numeric."
                                    : "",
                                },
                              }));
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DECIMAL" && (
                      <>
                        <Input
                          type="text"
                          size="small"
                          variant="outlined"
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          name="value"
                          divClass={classes.inputClass}
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) => {
                            const onlyDecimals = e.target.value.replace(
                              /[^0-9.]/g,
                              "",
                            ); // Allow numbers and dots
                            if (/^\d*\.?\d*$/.test(onlyDecimals)) {
                              // Ensure valid decimal format
                              this.handleChangeAddSpec(
                                {
                                  target: {
                                    name: e.target.name,
                                    value: onlyDecimals,
                                  },
                                },
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              );
                            }
                          }}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            const format =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.format ||
                              row.format ||
                              "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            } else {
                              this.setState((prevState) => ({
                                formDataAddSpec: {
                                  ...prevState.formDataAddSpec,
                                  [`${row.specId}_${row.id}`]: {
                                    ...prevState.formDataAddSpec[
                                      `${row.specId}_${row.id}`
                                    ],
                                    value: isNaN(value) ? "" : value,
                                  },
                                },
                                errors: {
                                  ...prevState.errors,
                                  [`${row.specId}_${row.id}`]: isNaN(value)
                                    ? "Value must be numeric."
                                    : "",
                                },
                              }));
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DATE" && (
                      <>
                        <FormControl
                          variant="outlined"
                          size="small"
                          fullWidth
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        >
                          <InputLabel style={{ background: "#fff" }} shrink>
                            DD-MM-YYYY
                          </InputLabel>
                          <Input
                            type="date"
                            //size="small"
                            //variant="outlined"
                            //placeholder="YYYY-MM-DD"
                            //placeholder={t('VALUE') + ' *'}
                            //placeholder={t('VALUE')}
                            name="value"
                            divClass={classes.inputClass}
                            //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                            value={
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value !== undefined
                                ? this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ].value
                                : row.value || ""
                            }
                            onChange={(e) =>
                              this.handleChangeAddSpec(
                                e,
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              )
                            }
                            onBlur={(e) => {
                              const value = e.target.value;
                              // Validate date format
                              if (!value) {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "Please enter a valid date.",
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "",
                                  },
                                }));
                              }
                            }}
                            fullWidth
                          />
                        </FormControl>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DATETIME" && (
                      <>
                        <FormControl
                          variant="outlined"
                          size="small"
                          fullWidth
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        >
                          <InputLabel style={{ background: "#fff" }} shrink>
                            DD-MM-YYYY HH:MM
                          </InputLabel>
                          <Input
                            type="datetime-local"
                            //size="small"
                            //variant="outlined"
                            //placeholder="YYYY-MM-DD HH:MM:SS"
                            //placeholder={t('VALUE') + ' *'}
                            //placeholder={t('VALUE')}
                            name="value"
                            divClass={classes.inputClass}
                            //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                            /*value={
                                                            this.state.formDataAddSpec[`${row.specId}_${row.id}`]?.value !== undefined
                                                              ? this.state.formDataAddSpec[`${row.specId}_${row.id}`].value
                                                              : row.value || ''
                                                        }*/
                            value={normalizeDateTime(
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value !== undefined
                                ? this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ].value
                                : row.value || "",
                            )}
                            onChange={(e) =>
                              this.handleChangeAddSpec(
                                e,
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              )
                            }
                            onBlur={(e) => {
                              const value = e.target.value;
                              // Validate date format
                              if (!value) {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value:
                                      "Please enter a valid date and time.",
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "",
                                  },
                                }));
                              }
                            }}
                            fullWidth
                          />
                        </FormControl>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {(row?.valueType?.toUpperCase() === "ENUMERATION" ||
                      row?.valueType?.toUpperCase() === "ENUM") && (
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.customeSelectLabel}
                        error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        fullWidth
                      >
                        <InputLabel
                          id={`enumSpecLabel_${row.specId}_${row.id}`}
                          style={{ background: "#fff" }}
                          shrink
                        >
                          {t("VALUE")}
                        </InputLabel>
                        <Select
                          size={"small"}
                          variant={"outlined"}
                          name="value"
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          native
                          label="VALUE"
                          labelId={`enumSpecLabel_${row.specId}_${row.id}`}
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                        >
                          <option value="-">Select</option>
                          {row?.characteristicValueSpecification?.map(
                            (option) => (
                              <option key={option.id} value={option.value}>
                                {option.id} : {option.value}
                              </option>
                            ),
                          )}
                        </Select>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <FormHelperText>
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}
                    {row?.valueType?.toUpperCase() === "BOOLEAN" && (
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.customeSelectLabel}
                        error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        fullWidth
                      >
                        <InputLabel
                          id={`enumSpecLabel_${row.specId}_${row.id}`}
                          style={{ background: "#fff" }}
                          shrink
                        >
                          {t("VALUE")}
                        </InputLabel>
                        <Select
                          size={"small"}
                          variant={"outlined"}
                          name="value"
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          native
                          label="VALUE"
                          labelId={`enumSpecLabel_${row.specId}_${row.id}`}
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                        >
                          <option value="-">Select</option>
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </Select>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <FormHelperText>
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}
                    <span style={{ textTransform: "capitalize" }}>
                      {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                      row?.valueType?.toUpperCase() === "ENUM"
                        ? "(Enum)"
                        : `(` + row?.valueType.toLowerCase() + `)`}
                    </span>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
            {!this.state.showLoading &&
              this.state.productCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="center"
                    style={{ textAlign: "center" }}
                  >
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  PaginationCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageCharacteristics}
            onChange={this.handleChangeRowsPerPageCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalCharacteristicsCount /
              this.state.rowsPerPageCharacteristics,
          )}
          onChange={this.handleChangePageCharacteristics}
          page={this.state.pageCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  SearchSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.name}
            name={"name"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.characteristicDescription}
            name={"characteristicDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getCharacteristicList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchCharacteristic}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  onCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getCharacteristicList();
    }
  };

  handleChangePageCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageCharacteristics: newPage,
        startRecordCharacteristics:
          this.state.rowsPerPageCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageCharacteristics = (event) => {
    this.setState(
      {
        pageCharacteristics: 1,
        rowsPerPageCharacteristics: event.target.value,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  clearSearchCharacteristic = () => {
    this.setState(
      {
        characteristicDescription: "",
        name: "",
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  selectCharacteristicDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-characteristic-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };

  render() {
    const { t, open, productId, productName, onClose } = this.props;
    const { classes: jssClasses } = this.props;
    this.state.selectedProductId = productId;
    return (
      <Dialog
        open={open}
        fullWidth
        maxWidth="lg"
        disableScrollLock={true}
        // PaperComponent={this.selectCharacteristicDialog}
        PaperComponent={DraggableResizablePaper}
        aria-labelledby="select-characteristic-dialog"
        PaperProps={{
          style: {
            height: window.innerHeight > 700 ? "600px" : "90vh", // Set a fixed height
            minHeight: "500px",
            margin: 0, // Optional: Ensures it doesn't shrink too much
          },
          // className: jssClasses.resizablePaper,
        }}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            onClose();
          }
        }}
      >
        <DialogTitle
          id="select-characteristic-dialog"
          style={{ cursor: "move" }}
        >
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {productName
                ? `${t("PRODUCT_SPECIFICATION")} for: ${productName}`
                : `${t("PRODUCT_SPECIFICATION")}`}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={(event) => onClose()}
                onClick={(event) => onClose()}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <div
            style={{
              borderRadius: "8px",
              border: "1px solid lightgrey",
              background: "white",
              marginBottom: "20px",
            }}
          >
            <Grid container spacing={0}>
              <>
                {this.state.productSpecifications.length > 0 && (
                  <Grid
                    item
                    style={{
                      borderRight: "1px solid lightgrey",
                      padding: "1rem",
                    }}
                    size={{
                      xs: 12,
                      md: 3,
                    }}
                  >
                    <SimpleTreeView
                      className="specificationNodeRoot specificationNodeRootTreeView"
                      expanded={this.state.expandedNodes}
                    >
                      {this.renderTreeItems(this.state.productSpecifications)}
                    </SimpleTreeView>
                  </Grid>
                )}
                {/*!this.state.showLoading && this.state.productSpecifications.length === 0 && (
                                    <Grid item xs={12} style={{ overflow: 'hidden', padding: '1rem' , textAlign:'center'}}>{t('NO_SPECIFICATION_FOUND')}</Grid>
                                )*/}
                {this.state.productCharacteristics.length > 0 && (
                  <Grid
                    item
                    style={{ overflow: "hidden", padding: "1rem" }}
                    size={{
                      xs: 12,
                      md: 9,
                    }}
                  >
                    <>
                      <Typography
                        variant="h6"
                        component="div"
                        style={{
                          marginBottom: "20px",
                          borderBottom: "1px solid lightgrey",
                          padding: "1rem",
                        }}
                      >
                        {this.state.selectedSpecificationDescription}{" "}
                        {t("PRODUCT_CHARACTERISTIC")}
                      </Typography>
                      <Card
                        variant="outlined"
                        style={{ borderRadius: "8px", marginBottom: "20px" }}
                      >
                        <div className={classes.root}>
                          {this.SearchSectionCharacteristic()}
                          {this.TableSectionCharacteristic()}
                          {this.state.totalCharacteristicsCount >
                            this.state.rowsPerPageCharacteristics &&
                            this.PaginationCharacteristic()}
                        </div>
                      </Card>
                    </>
                  </Grid>
                )}
                {!this.state.showLoading &&
                  this.state.productCharacteristics.length === 0 && (
                    <Grid
                      item
                      style={{
                        overflow: "hidden",
                        padding: "1rem",
                        textAlign: "center",
                      }}
                      size={{
                        xs: 12,
                        md: 9,
                      }}
                    >
                      {t("NO_CHARACTERISTIC_FOUND")}
                    </Grid>
                  )}
              </>
            </Grid>
          </div>
          <Loader loading={this.state.showLoading} />
        </DialogContent>
        <DialogActions>
          {/*<Button onClick={onClose} color="primary">Cancel</Button>*/}
          {this.state.existingProductSpecification
            ? !this.state.showProductSpecification && (
                <Button onClick={this.handleAssignAll} color="primary">
                  Update
                </Button>
              )
            : ""}
        </DialogActions>
      </Dialog>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '65vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(OfferingProductSpecCharacteristicsDialog));
